module.exports = __webpack_public_path__ + "img/icon-1-3.957c1257.png";